export const HTML_PREVIEW_LINK_MESSAGE = "izanagi:html-preview-link";

/**
 * 未保存の編集内容を srcdoc で描くための HTML を組み立てる。srcdoc は親ページの URL を基準にするため、保存先の
 * URL を base に入れて相対パスを解決させる。作者の base が相対なら同じく保存先の URL を基準に解決し直す。
 * 保存済みの HTML と同じく、バックエンドが配るリンクの横取りスクリプトも読み込ませる。
 */
export function toHtmlPreviewSrcDoc(
	source: string,
	baseHref: string,
	linkScriptHref: string,
): string {
	const doc = new DOMParser().parseFromString(source, "text/html");
	const authorBase = doc.querySelector("base[href]");
	const authorBaseHref = authorBase?.getAttribute("href");
	if (authorBase && authorBaseHref != null) {
		if (URL.canParse(authorBaseHref, baseHref)) {
			authorBase.setAttribute("href", new URL(authorBaseHref, baseHref).href);
		}
	} else {
		const base = doc.createElement("base");
		base.setAttribute("href", baseHref);
		doc.head.prepend(base);
	}
	const script = doc.createElement("script");
	script.setAttribute("src", linkScriptHref);
	doc.head.append(script);
	// public id を落とすと quirks モードの文書が標準モードで描かれ、保存後の表示と食い違う。
	const doctype = doc.doctype ? new XMLSerializer().serializeToString(doc.doctype) : "";
	return doctype + doc.documentElement.outerHTML;
}

/**
 * プレビュー配下の URL を、環境内のワークスペース相対パスへ戻す。配下でない、またはファイル名に
 * 含まれ得ない "/" が符号化されていてパスを組み替えてしまう場合は null。
 */
export function workspacePathFromPreviewHref(href: string, previewRootHref: string): string | null {
	const url = new URL(href);
	const root = new URL(previewRootHref);
	if (url.origin !== root.origin || !url.pathname.startsWith(root.pathname)) return null;
	const segments = url.pathname.slice(root.pathname.length).split("/").map(decodePathSegment);
	if (segments.some((segment) => segment.includes("/"))) return null;
	const path = segments.join("/");
	return path === "" ? null : path;
}

/** URL は "100%.html" の "%" をそのまま残すため、復号できない区切りはファイル名の文字として扱う。 */
export function decodePathSegment(segment: string): string {
	try {
		return decodeURIComponent(segment);
	} catch (err) {
		if (err instanceof URIError) return segment;
		throw err;
	}
}

/**
 * ブラウザの新しいタブで開いてよい外部の http(s) URL か。アプリやプレビューと同じオリジンの URL は
 * アプリのオリジンでページとして開かせないよう除く。
 */
export function isExternalLinkHref(href: string, previewRootHref: string): boolean {
	const url = new URL(href);
	return (
		(url.protocol === "http:" || url.protocol === "https:") &&
		url.origin !== new URL(previewRootHref).origin &&
		url.origin !== window.location.origin
	);
}
